var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 768 768"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M576 408H192c-13.12 0-24-10.88-24-24s10.88-24 24-24h384c13.12 0 24 10.88 24 24s-10.88 24-24 24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M384 600c-13.12 0-24-10.88-24-24V192c0-13.12 10.88-24 24-24s24 10.88 24 24v384c0 13.12-10.88 24-24 24"
  })));
};
export default SvgAdd;